import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";

import { storylineReducer } from "./storyline/reducers";
import { appReducer } from "./app/reducers";
import { notificationsReducer } from "./notifications/reducers";
import { tracingReducer } from "./tracing/reducers";
import { vsCodeReducer } from "./vscode/reducers";


export const store = configureStore({
    reducer: {
        app: appReducer,
        storyline: storylineReducer,
        notifications: notificationsReducer,
        traces: tracingReducer,
        vsCode: vsCodeReducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false, immutableCheck: false }),
    devTools: {
        serialize: {
            options: {
                map: true
            }
        }
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useThunkDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();